import { requiredIf, helpers } from 'vuelidate/lib/validators'
import moment from 'moment'

const categorie = (cat) => {
  const categories = ['RETRAITE', 'NOUVEAU', 'SALARIE']
  var indexOfRed = categories.indexOf(cat)
  return indexOfRed != -1
}

const genre = (g) => {
  const genres = ['M', 'F']
  var indexOfRed = genres.indexOf(g)
  return indexOfRed != -1
}

const provenance = (p) => {
  const provenances = ['PARIS', 'PROVINCE', 'ETRANGER', 'PROVENANCE']
  var indexOfRed = provenances.indexOf(p)
  return indexOfRed != -1
}

const civilite = (c) => {
  if (!c) return true
  if (c.id && c.label) return true
  return false
}

const contact = (contactNotNull) => ({
  civilite: {
    required: requiredIf(contactNotNull),
  },
  nom: {
    required: requiredIf(contactNotNull),
  },
  prenom: {},
  fonction: {},
  telFixe: {},
  telPortable: {},
  fax: {},
  mail: {},
})

const provenanceValidator = (paysExercice, adresse) => (prov) => {
  if (prov != null && prov != undefined && prov.id != null) {
    if (
      (paysExercice == null || (paysExercice && paysExercice.id == 716)) &&
      (adresse == null ||
        (adresse && (adresse.pays == null || adresse.pays.id == 716)))
    ) {
      return prov.id != 18
    } else {
      return prov.id == 18
    }
  } else {
    return false
  }
}

const minDateOrEqual = (min) => {
  return helpers.withParams(
    { type: 'minDateOrEqual', min },
    (value) => moment(min).diff(moment(value)) <= 0,
  )
}

export {
  categorie,
  genre,
  provenance,
  contact,
  provenanceValidator,
  civilite,
  minDateOrEqual,
}
